jQuery( document ).ready(function() {
  $(".popUp-close-button").click(function(){
    $('.popUp').hide();
  }); 
  var is_modal_show = sessionStorage.getItem('alreadyShow');
  if(is_modal_show != 'alredy shown'){
    $(".popUp").show()
    sessionStorage.setItem('alreadyShow','alredy shown');
  }
});